import React, { useContext } from 'react';
import { IconProps } from '../iconProps';
import { UiContext } from 'shared/lib/contexts/uiContext';
import cx from 'classnames';
import { defaultSpacingPresets } from 'shared/hooks/useGetSpacing';

export default function IconMov({
  isAutoscallable = true,
  sizeKey = '17x22',
  onClick,
  style,
}: IconProps) {
  const {
    spacings: {
      icons: { [sizeKey]: size },
    },
  } = useContext(UiContext);

  const w = isAutoscallable ? size.w : defaultSpacingPresets.icons[sizeKey].w;
  const h = isAutoscallable ? size.h : defaultSpacingPresets.icons[sizeKey].h;

  return (
    <svg
      className={cx('icon', { 'icon-disabled': !onClick })}
      onClick={onClick}
      style={style}
      width={w}
      height={h}
      viewBox="0 0 17 22"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.9219 5.78944V20.263C16.9219 21.2224 16.1416 22 15.1794 22H1.82059C0.858094 22 0.078125 21.2224 0.078125 20.263V1.73697C0.078125 0.777562 0.858094 0 1.82059 0H11.1135L16.9219 5.78944Z"
        fill="#76B8B7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.1289 15.6532H12.3864L11.2259 12.3914H12.0496L12.7766 14.5398L13.5002 12.3914H14.3053L13.1289 15.6532ZM9.60688 15.7494C8.55844 15.7494 8.03456 15.1764 8.03456 14.03C8.03456 13.4786 8.16037 13.052 8.412 12.7502C8.66362 12.4488 9.06169 12.2979 9.60688 12.2979C10.1476 12.2979 10.5436 12.4488 10.7952 12.7502C11.0468 13.052 11.1727 13.4786 11.1727 14.03C11.1727 14.5731 11.0468 14.9956 10.7952 15.2971C10.5436 15.5989 10.1476 15.7494 9.60688 15.7494ZM10.1713 13.2449C10.0589 13.0799 9.87088 12.9977 9.60688 12.9977C9.34459 12.9977 9.15553 13.0819 9.039 13.2511C8.92247 13.4199 8.86438 13.6797 8.86438 14.03C8.86438 14.3782 8.92212 14.6347 9.03728 14.7997C9.15278 14.9643 9.34253 15.0468 9.60688 15.0468C9.86675 15.0468 10.0538 14.9654 10.1682 14.8028C10.2827 14.6398 10.3398 14.3824 10.3398 14.03C10.3398 13.6715 10.2837 13.4095 10.1713 13.2449ZM6.77059 13.7313C6.77059 13.5388 6.75925 13.3882 6.73656 13.2806C6.71353 13.1727 6.67881 13.0998 6.63206 13.0613C6.58497 13.0228 6.50762 13.0039 6.39934 13.0039C6.27662 13.0039 6.14669 13.0493 6.00953 13.1407C5.87238 13.2318 5.7445 13.3439 5.62591 13.4766V15.6532H4.82084V13.7313C4.82084 13.5199 4.81156 13.3673 4.793 13.2727C4.77409 13.1785 4.74075 13.1101 4.69297 13.0675C4.64519 13.0252 4.56406 13.0039 4.44959 13.0039C4.34991 13.0039 4.23441 13.0417 4.10344 13.1174C3.97247 13.193 3.82981 13.3126 3.67616 13.4766V15.6532H2.87109V12.3914H3.67616V12.8142C3.82569 12.6523 3.98278 12.5261 4.14709 12.4347C4.31141 12.3436 4.49325 12.2979 4.69297 12.2979C4.96556 12.2979 5.16666 12.3446 5.29659 12.4378C5.42653 12.5313 5.51556 12.6691 5.56334 12.8513C5.75069 12.665 5.92566 12.5261 6.08894 12.4347C6.25222 12.3436 6.44334 12.2979 6.66162 12.2979C6.97959 12.2979 7.21163 12.3883 7.35737 12.5684C7.50278 12.7489 7.57566 13.0514 7.57566 13.4766V15.6532H6.77059V13.7313Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.9211 5.46528V6.18578H12.1729C11.1897 6.18578 10.7363 5.38828 10.7363 4.40481V0H11.4555L16.9211 5.46528Z"
        fill="#AFDCDB"
      />
    </svg>
  );
}
